import { Group, GroupProps } from "@mantine/core"

interface Props extends GroupProps, React.PropsWithChildren {}

export function FormButtonGroup({ children, ...props }: Props) {
  return (
    <Group justify="flex-end" mt={"md"} {...props}>
      {children}
    </Group>
  )
}
